export default __webpack_public_path__ + "static/virtual-event-streaming-e8eae8e48a7557c19e259bf114e27e79.jpg";